import React, { useState, useEffect, useRef, useContext } from "react";
import style from "../styles/AuditReview.css";
import { ApiCall } from "./../../utility/ApiCalls";
import ToolTipClinicalAuditReviewForm from "../scripts/ToolTipClinicalAuditReviewForm";
import Timer from "../scripts/Timer";
import CustomModal from "../scripts/AuditModalBox";
import ModalPopUp from "../scripts/ModalPopUp";
import ConfirmationModal from "../Common/ConfirmationModal";
import PrecisionManufacturingIcon from "@mui/icons-material/PrecisionManufacturing";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import { error, event } from "jquery";
import { toast } from "react-toastify";
import "../styles/ClinicalAuditReviewForm.css";

import UserContext from "../Common/UserContext";
import Rebuttal from "../scripts/Rebuttal";
import PopOutModal from "../scripts/PopOutModal";
// import Box from "@mui/system/Box";
// import Typography from "@mui/material/Typography";
function ClinicalReviewAuditForRebuttal(auditdata) {
  const { userRole: user, setUser } = useContext(UserContext);

  console.log(auditdata);
  const FaxurlpdF = auditdata.data["Fax_URL"];
  const data = auditdata.data["Audit_data"];
  const customername =
    auditdata.data["Fax_Info"]["FirstName_CR"] +
    " " +
    auditdata.data["Fax_Info"]["LastName_CR"];
  const scoreacheived = auditdata.data["Score_Achieved"];
  const scoretotal = auditdata.data["Total_Score"];
  const showViewRebuttal = auditdata.data["Fax_Info"]["Rebuttal_Status"] == 1;

  console.log(showViewRebuttal);

  console.log(scoreacheived);

  const [activeCategory, setActiveCategory] = useState(null);
  const [activeQuestion, setActiveQuestion] = useState(null);
  const [selectedAnswers, setSelectedAnswers] = useState({});
  const [menuVisible, setMenuVisible] = useState(true);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [isModalOpen, setModalOpen] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [hasCustomStyle, setCustomStyle] = useState(false);
  const [isDiv1Visible, setDiv1Visible] = useState(true);
  const [totalScore, setTotalScore] = useState(0);
  const [ScoreAchieved, setScoreAchieved] = useState(0);
  const [qualityScore, setQualityScore] = useState(0);
  const [showAdditionalFields, setShowAdditionalFields] = useState(false);
  const [dropdownValue, setDropdownValue] = useState("");
  const [textBoxValue, setTextBoxValue] = useState("");
  const [commentValue, setCommentValue] = useState("");
  const [activeQuestionAnswer, setActiveQuestionAnswer] = useState("");
  const [showNAbutton, setShowNAbutton] = useState(false);
  const [showYesNobutton, setShowYesNobutton] = useState(false);
  const [submituBttonValue, SetsubmituBttonValue] = useState("");
  const [selectedOption, SetSelectedOption] = useState("");
  const [checkEventSavebutton, setCheckEventSavebutton] = useState("");
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [modalIsOpenMessage, setModalIsOpenMessage] = useState(false);
  const [isSaveDisabled, setIsSaveDisabled] = useState(false);
  const [isSubmitDisabled, setisSubmitDisabled] = useState(true);
  const [value, setValue] = useState("");
  const [isPdfVisible, setIsPdfVisible] = useState(false);
  const [filepath, setfilepath] = useState();
  const [isMagnifying, setIsMagnifying] = useState(false);

  const [isRebuattalClicked, setIsRebuttalClicked] = useState(false);

  const [isModalClosed, setIsModalClosed] = useState(false);

  const [questionsFromAuditData, setQuestionsFromAuditData] = useState([]);
  const [isSubmitInRebuttalPressed, setIsSubmitInRebuttalPressed] =
    useState(false);
  const [buttonAreYouSure, setButtonAreYouSure] = useState(false);

  const [isViewRebuttalactive, setIsViewRebuttalactive] = useState(false);
  const [statusOfRebuttalPopup, setStatusOfRebuttalPopup] = useState(
    auditdata.data["Fax_Info"]["Action"]
  );
  const [isYesButtonClicked, setIsYesButtonClicked] = useState(false);
  const eleRef = useRef(null);

  console.log("isSubmitInRebuttalPressed", isSubmitInRebuttalPressed);

  useEffect(() => {
    // Function to get the z-index of the element
    const getZIndex = () => {
      // Ensure the element is available
      if (eleRef.current) {
        // Get the computed style of the element
        const computedStyle = window.getComputedStyle(eleRef.current);

        // Access the z-index property
        const zIndex = computedStyle.getPropertyValue("z-index");

        // Log or use the z-index value as needed
        console.log("Z-index:-----------------", zIndex);
      }
    };

    // Call the function to get the z-index on mount
    getZIndex();

    // You can call this function whenever you need to get the updated z-index
    // For example, in response to an event or after a state change
  }, []);

  console.log(FaxurlpdF);
  const handlesetIsSubmitInRebuttalPressed = () => {
    setIsSubmitInRebuttalPressed(true);
  };

  const applyHtmlInlineStyle = () => {
    const htmlElement = document.documentElement;
    htmlElement.style.overflow = "hidden";
  };
  const startMagnifier = () => {
    if (isMagnifying == false) {
      setIsMagnifying(true);
    } else {
      setIsMagnifying(false);
    }
  };

  const clearMagnifier = () => {
    setIsMagnifying(false);
  };

  const showpdf = () => {
    setIsPdfVisible(!isPdfVisible);
  };

  const openCModal = () => {
    setModalIsOpen(true);
  };

  const closeCModal = () => {
    setModalIsOpen(false);
  };

  const handleConfirm = () => {
    // Perform the action you want to confirm (e.g., delete)
    // ...
    // Close the modal
    setCommentValue("");
    setCheckEventSavebutton("");
    setShowAdditionalFields(false);
    closeCModal();
  };
  async function getAuditData(e) {
    console.log("Inside getValidatedTask API call ");
    console.log(sessionStorage.getItem("ActiveTaskID"));
    const ret = await ApiCall(
      {
        taskID: sessionStorage.getItem("ActiveTaskID"),
        // taskID: "110003",
        clinical_data: "0",
      },
      "vcare-ui",
      "vcareui_clinicalaudit"
    );
    const repsonse = ret.body;
    console.log(
      "setting state ===================================================== "
    );
    console.log(ret.body);

    data[activeCategory] = repsonse.Audit_data["Tasking and Documentation"];

    return repsonse;
  }
  async function UpdateScore(
    decision,
    question_id,
    score,
    comment,
    reason,
    error,
    sectionid
  ) {
    console.log("Inside UpdateScore API call ");
    console.log(sessionStorage.getItem("ActiveTaskID"));
    const ret = await ApiCall(
      {
        task_id: sessionStorage.getItem("ActiveTaskID"),
        decision: decision,
        question_id: question_id,
        score: score,
        comment: comment,
        error_id: error,
        reason: reason,
      },

      "vcare-ui",
      "vcareui_updatequestionscore"
    );
    const repsonse = ret.body;
    console.log(
      "setting state ===================================================== "
    );
    console.log(ret.body);

    setScoreAchieved(repsonse.total_score);

    console.log(repsonse.enable_submit);
    setQualityScore(repsonse.quality_score);
    if (repsonse.enable_submit === "True") {
      setisSubmitDisabled(false);
    }
    data[activeCategory].Section_Answered = repsonse.section_answered;
    const da = filterDataBySequence(ret.audit_data, sectionid);
    data[Object.keys(da.Audit_data)] =
      da.Audit_data[Object.keys(da.Audit_data)];
    toast.success("Review Saved successfully for this question", {
      autoClose: true,
    });
    setCheckEventSavebutton("");
    setIsSaveDisabled(true);

    // setModalIsOpen(true);
    //alert("Review Saved successfully for this question");

    return repsonse;
  }
  async function SubmitClinicalAuditForm() {
    console.log("Inside submit Audit form API call ");
    const ret = await ApiCall(
      {
        taskID: sessionStorage.getItem("ActiveTaskID"),
        status: "4",
      },
      "vcare-ui",
      "vcareui_saveauditdecision"
    );
    const repsonse = ret.body;
    setModalIsOpenMessage(true);

    return repsonse;
  }

  async function resetaudit() {
    console.log("Inside submit Audit form API call ");
    const ret = await ApiCall(
      {
        taskID: sessionStorage.getItem("ActiveTaskID"),
      },
      "vcare-ui",
      "vcareui_resetauditdata"
    );
    const repsonse = ret.body;
    toast.success("Audit data has been Reset", { autoClose: true });
    setTimeout(() => {
      window.location.reload();
    }, 6000);

    return repsonse;
  }
  async function resetauditforsection(sectionid) {
    console.log("Inside submit Audit form API call ");
    const ret = await ApiCall(
      {
        taskID: sessionStorage.getItem("ActiveTaskID"),
        section_id: sectionid,
      },
      "vcare-ui",
      "resetauditsectiondata"
    );
    const repsonse = ret.body;
    toast.success("Audit data for section has been reset", { autoClose: true });
    const da = filterDataBySequence(ret.audit_data, sectionid);
    data[Object.keys(da.Audit_data)] =
      da.Audit_data[Object.keys(da.Audit_data)];

    const initialSelectedAnswers = {};
    Object.keys(data).map((category) => {
      initialSelectedAnswers[category] = {};
      Object.keys(data[category]).map((question) => {
        if (question === "Sequence") {
          return null;
        }
        const questionData = data[category][question];
        const isDecisionYes = questionData.Decision;
        const answer = isDecisionYes ? questionData["Max Score"] : 0;

        initialSelectedAnswers[category][questionData.Question_ID] = {
          parameters: questionData.Parameters,
          answer: isDecisionYes,
        };
      });
    });
    setSelectedAnswers(initialSelectedAnswers);
    handleCategoryClick(Object.keys(da.Audit_data));
    // getAuditData();
    return repsonse;
  }
  const toggleDivVisibility = () => {
    setDiv1Visible(!isDiv1Visible);
  };
  const toggleCustomStyle = () => {
    setCustomStyle(!hasCustomStyle);
  };

  const openModal = () => {
    setIsPdfVisible(true);
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
  };
  const openDialog = () => {
    setIsDialogOpen(true);
  };
  function filterDataBySequence(data, Section_ID) {
    const filteredData = {};

    // Loop through the categories
    for (const category in data) {
      const filteredCategory = {};

      // Loop through the questions in the category
      for (const question in data[category]) {
        if (data[category][question].Section_ID === Section_ID) {
          // If the Section matches, add the question to the filtered category
          filteredCategory[question] = data[category][question];
        }
      }

      if (Object.keys(filteredCategory).length > 0) {
        // If there are questions in the filtered category, add it to the filtered data
        filteredData[category] = filteredCategory;
      }
    }

    return filteredData;
  }

  const closeDialog = () => {
    setIsDialogOpen(false);
  };

  const handleMenuButtonClick = () => {
    setMenuVisible(false);
    setSidebarOpen(true);
  };

  const handleCloseButtonClick = () => {
    setMenuVisible(true);
    setSidebarOpen(false);
  };

  const handleCategoryClick = (category) => {
    console.log(checkEventSavebutton);
    SetSelectedOption("");
    setDiv1Visible(true);
    setShowAdditionalFields(false);
    if (activeCategory === category) {
      setActiveQuestion(null);
      setActiveCategory(null);
      setShowYesNobutton(false);
    } else {
      setActiveCategory(category);
    }
  };
  const handleRadioChange = (
    event,
    category,
    questionId,
    parameters,
    questionData
  ) => {
    const answer = event.target.value === "Yes" ? questionData["Max Score"] : 0;
    const isYes = event.target.value === "Yes";
    const currentScore = selectedAnswers[category]?.[questionId]?.answer || 0;
    const maxScore = questionData["Max Score"];

    setActiveQuestionAnswer(event.target.value);
    let newTotalScore = totalScore;

    if (isYes) {
      newTotalScore += maxScore - currentScore;
    } else {
      newTotalScore -= currentScore;
    }

    event.stopPropagation();
    setSelectedAnswers({
      ...selectedAnswers,
      [category]: {
        ...selectedAnswers[category],
        [questionId]: {
          parameters,
          answer: event.target.value,
        },
      },
    });
  };
  const handleQuestionClick = (category, question, event) => {
    console.log(checkEventSavebutton);
    if (checkEventSavebutton === "1") {
      setModalIsOpen(true);

      return;
    }
    setIsSaveDisabled(false);

    setShowAdditionalFields(false);
    if (event.target.type === "radio") {
      if (activeQuestion === question) {
      } else {
        setActiveQuestion(question);
        setActiveCategory(category);
      }
      return;
    }
    if (activeQuestion === question) {
      setActiveQuestion(null);
      setShowAdditionalFields(false);
      setShowNAbutton(false);
      setShowYesNobutton(false);
      setValue("");
      return;
    } else {
      setActiveQuestion(question);
      setActiveCategory(category);
    }
    const questiondata = data[activeCategory][question];
    SetSelectedOption("");
    setTextBoxValue("");
    setCommentValue("");
    setValue("");
    setShowYesNobutton(true);
    // setTextBoxValue('');
    if (questiondata.Error_ID != null) {
      setValue(questiondata.Error_ID);
    } else {
      setValue("");
    }

    setCommentValue(questiondata.Comment);
    SetSelectedOption(questiondata.Decision);
    SetsubmituBttonValue(questiondata.Decision);
    if (questiondata.Decision === "No") {
      setShowAdditionalFields(true);
    } else {
      setShowAdditionalFields(false);
    }
    if (questiondata.NA === "Yes") {
      setShowNAbutton(true);
    } else {
      setShowNAbutton(false);
    }
  };
  let noyesbutton = "";
  const handleNoButtonClick = () => {
    SetsubmituBttonValue("No");
    setShowAdditionalFields(true);
    if (activeCategory && activeQuestion) {
      // const updatedAnswers = { ...selectedAnswers };
      // if (updatedAnswers[activeCategory] && updatedAnswers[activeCategory][activeQuestion]) {
      //     updatedAnswers[activeCategory][activeQuestion].answer = 'No'
      //     setSelectedAnswers(updatedAnswers);
      // }
      // setSelectedAnswers({
      //     ...selectedAnswers,
      //     [activeCategory]: {
      //         ...selectedAnswers[activeCategory],
      //         [activeQuestion]: {
      //             parameters: '',
      //             answer: 'No',
      //         },
      //     },
      // });
      // setActiveQuestionAnswer('No');
    }
    const updatedAnswers = { ...selectedAnswers };
    if (activeCategory && activeQuestion) {
      const questiondata = data[activeCategory][activeQuestion];
      const activeCategoryAnswers = { ...updatedAnswers[activeCategory] };
      Object.keys(activeCategoryAnswers).map((questionId) => {
        if (questiondata.Question_ID == questionId) {
          activeCategoryAnswers[questionId].answer = "No";
        }
      });
      updatedAnswers[activeCategory] = activeCategoryAnswers;
    }
    setSelectedAnswers(updatedAnswers);
  };
  const handleNAButtonClick = () => {
    setShowAdditionalFields(false);
    const updatedAnswers = { ...selectedAnswers };
    if (activeCategory && activeQuestion) {
      const questiondata = data[activeCategory][activeQuestion];
      const activeCategoryAnswers = { ...updatedAnswers[activeCategory] };
      Object.keys(activeCategoryAnswers).map((questionId) => {
        if (questiondata.Question_ID == questionId) {
          activeCategoryAnswers[questionId].answer = submituBttonValue;
        }
      });
      updatedAnswers[activeCategory] = activeCategoryAnswers;
    }
    setSelectedAnswers(updatedAnswers);
  };
  const wrapsecondStyle = {
    background:
      "url(/img/tophdr.png), lightgray 0px -380.029px / 100.556% 1322.513% no-repeat",
  };

  const handleYesButtonClick = () => {
    setShowAdditionalFields(false);
    SetsubmituBttonValue("Yes");
    setTextBoxValue("");
    setCommentValue("");

    const updatedAnswers = { ...selectedAnswers };
    if (activeCategory && activeQuestion) {
      const questiondata = data[activeCategory][activeQuestion];
      const activeCategoryAnswers = { ...updatedAnswers[activeCategory] };
      Object.keys(activeCategoryAnswers).map((questionId) => {
        if (questiondata.Question_ID == questionId) {
          activeCategoryAnswers[questionId].answer = "Yes";
        }
      });
      updatedAnswers[activeCategory] = activeCategoryAnswers;
    }
    setSelectedAnswers(updatedAnswers);
  };

  const handleSave = (event) => {
    const error = +value;
    const updatedAnswers = { ...selectedAnswers };
    if (activeCategory && activeQuestion) {
      const questiondata = data[activeCategory][activeQuestion];
      const activeCategoryAnswers = { ...updatedAnswers[activeCategory] };
      Object.keys(activeCategoryAnswers).map((questionId) => {
        if (questiondata.Question_ID == questionId) {
          activeCategoryAnswers[questionId].answer = submituBttonValue;
        }
      });
      data[activeCategory][activeQuestion].Decision = submituBttonValue;
      data[activeCategory][activeQuestion].Error_ID = error;
      data[activeCategory][activeQuestion].Comment = commentValue;
      updatedAnswers[activeCategory] = activeCategoryAnswers;
    }
    setSelectedAnswers(updatedAnswers);
    const reason = dropdownValue;
    const comment = commentValue;
    const type = submituBttonValue;

    const questiondata = data[activeCategory][activeQuestion];
    let score = questiondata["Max Score"];
    if (type === "No" || type === "NA") {
      score = 0;
    }
    // if (event.target.value == "No" && event.target.value == "NA") {
    //     score == 0;
    // }
    // else {
    //     comment == '';
    //     type = '';
    // }
    setIsSaveDisabled(true);
    UpdateScore(
      type,
      questiondata.Question_ID,
      score,
      comment,
      reason,
      error,
      data[activeCategory].Section_ID
    );
    //SubmitClinicalAuditForm(reason, comment, type);
    setShowAdditionalFields(false);
    setTextBoxValue("");
    setCommentValue("");
    SetSelectedOption("");
  };

  useEffect(() => {
    Object.keys(data).map((item) =>
      setQuestionsFromAuditData((prevValue) => [...prevValue, item])
    );
  }, []);

  const handleRebuttal = () => {
    setIsRebuttalClicked(true);
  };

  console.log(questionsFromAuditData);

  const handleSubmit = (event) => {
    SubmitClinicalAuditForm();
  };
  const handleReset = (event) => {
    resetaudit();
  };
  const handleResetforcategory = (sectionid) => {
    resetauditforsection(sectionid);
  };
  const handlecommentchange = (e) => {
    setCommentValue(e.target.value);
    setCheckEventSavebutton("1");
  };
  const handleOptionChange = (event) => {
    setCheckEventSavebutton("1");
    SetsubmituBttonValue(event.target.value);
    SetSelectedOption(event.target.value);
    if (event.target.value === "Yes" || event.target.value === "NA") {
      setShowAdditionalFields(false);
      setCommentValue("");
      setValue("");
    } else {
      setShowAdditionalFields(true);
    }
  };
  const handleChangeselect = (event) => {
    setValue(event.target.value);
  };
  // useEffect(() => {
  //     setTotalScore(scoreacheived);

  // }, []);

  useEffect(() => {
    setTotalScore(scoretotal);
    setScoreAchieved(scoreacheived);
    const initialSelectedAnswers = {};
    Object.keys(data).map((category) => {
      initialSelectedAnswers[category] = {};
      Object.keys(data[category]).map((question) => {
        if (question === "Sequence") {
          return null;
        }
        const questionData = data[category][question];
        const isDecisionYes = questionData.Decision;
        const answer = isDecisionYes ? questionData["Max Score"] : 0;

        initialSelectedAnswers[category][questionData.Question_ID] = {
          parameters: questionData.Parameters,
          answer: isDecisionYes,
        };
      });
    });
    setSelectedAnswers(initialSelectedAnswers);
    applyHtmlInlineStyle();

    // Clean up by removing the inline CSS when the component unmounts
    return () => {
      const htmlElement = document.documentElement;
      htmlElement.style.overflow = ""; // Remove the inline CSS
    };
  }, [data]);
  const stylesnew = {
    "*": {
      margin: "0",
      padding: "0",
      "box-sizing": "border-box",
      "font-family": "var(--font-family)",
    },
  };

  const handleIsModalClosed = () => {
    setIsModalClosed(true);
    if (isSubmitInRebuttalPressed) setIsSubmitInRebuttalPressed(false);
  };

  console.log("isModalClosed", isModalClosed);
  console.log("button are you sure", buttonAreYouSure);
  return (
    <>
      <div className="main-container" style={stylesnew}>
        <div className="second-topHeader-wrap" style={wrapsecondStyle}>
          <div className="itemleft">
            <div className="score">
              Score Achieved
              <span className="badge">{ScoreAchieved}%</span>
            </div>
            <div className="hdr">Clinical Review Audit</div>
          </div>

          {/* <button onClick={startMagnifier}>Start Magnifier</button>
                    <button onClick={clearMagnifier}>Clear Magnifier</button> */}

          <div className="itemright">
            <div className="time" onClick={handleRebuttal}>
              {/* <span className='btnrebuttal'>{!showViewRebuttal?'File Rebuttal':'View Rebuttal'}</span> */}
              <span className="btnrebuttal">
                {statusOfRebuttalPopup} Rebuttal
              </span>
            </div>

            <div class="time" onClick={startMagnifier}>
              {isMagnifying === true ? (
                <img src="./img/zoom_in.png" alt="Zoom" />
              ) : (
                <img src="./img/zoom_out.png" alt="Zoom" />
              )}
              {/* <img src="./img/zoom_in.png" alt="Zoom" /> */}
              <span>Zoom</span>
            </div>
            <div className="time">
              <img src="./img/time.svg" alt="Time Spent" />
              <span>Task ID: {sessionStorage.getItem("ActiveTaskID")} </span>
              <span>Patient Name: {customername} </span>
            </div>
            <div className="time">
              <img src="./img/time.svg" alt="Time Spent" />
              Time: <Timer start={Date.now()} />
            </div>
            <div class="pdfview primary" onclick="window.dialog.showModal();">
              <img src="./img/pdfview.svg" alt="PDF View" onClick={openModal} />
              <span onClick={openModal}>PDF Preview</span>
              {/* <div onClick={showpdf}>➖</div> */}
            </div>
            {/* <div className="pdfview primary" >
                            <div className='pdfmain' onClick={openModal}>
                                <img src="./img/pdfview.svg" alt="PDF View" />
                                <span>PDF Preview</span>
                            </div>
                           
                        </div> */}
          </div>
        </div>
        <div className="body-container">
          <div className={`sidebar ${isDiv1Visible ? "open" : ""}`}>
            <header>
              <div
                className={`menu-btn ${isDiv1Visible ? "hidden" : "visible"}`}
                onClick={toggleDivVisibility}
              >
                <img className="icon-btn" src="img/round-right.svg"></img>
              </div>
              <div
                className={`close-btn ${isDiv1Visible ? "visible" : "hidden"}`}
                onClick={toggleDivVisibility}
              >
                <img className="icon-btn" src="img/round-left.svg"></img>
              </div>
            </header>
            <div className="accordion">
              {Object.keys(data).map((category) => (
                <div className="accordion__item" key={category}>
                  <div
                    className={`accordion__item__header ${
                      activeCategory === category ? "active" : ""
                    }`}
                    onClick={() => handleCategoryClick(category)}
                  >
                    {data[category].Section_Answered === 1 ? (
                      <div id="tick-mark"></div>
                    ) : (
                      <div>
                        {" "}
                        <img src="./img/hourglass.svg"></img>
                      </div>
                    )}

                    <span> {category}</span>
                    <div className="score_badge">
                      {" "}
                      {data[category].Achieved_Score +
                        "/" +
                        data[category].Max_Score}{" "}
                    </div>
                    {user == "Auditor" && (
                      <div
                        className="resetimage"
                        onClick={() =>
                          handleResetforcategory(data[category].Section_ID)
                        }
                      >
                        <RestartAltIcon />
                      </div>
                    )}
                  </div>
                  {activeCategory === category && (
                    <div
                      className="accordion__item__content"
                      style={{ display: "block" }}
                    >
                      {Object.keys(data[category]).map((question) => {
                        if (
                          question === "Sequence" ||
                          question === "Section_Answered" ||
                          question === "Max_Score" ||
                          question === "Achieved_Score" ||
                          question === "Section_ID"
                        ) {
                          return null;
                        }
                        const questionData = data[category][question];
                        const isQuestionActive = activeQuestion === question;
                        const isactiveQuestionChecked =
                          activeQuestionAnswer === "Yes";
                        return (
                          <>
                            <ToolTipClinicalAuditReviewForm
                              information={questionData.OperationalDefinition}
                            ></ToolTipClinicalAuditReviewForm>

                            {/* <ToolTipClinicalAuditReviewForm information='<div>Hi there this is something i want to tell for such a long time that i cannot </div>'></ToolTipClinicalAuditReviewForm> */}
                            {/* <ToolTipClinicalAuditReviewForm information='<div style="background-color: #f9f9f9; list-style-type:decimal; "> 

  <h4>Referral to MD Criteria:</h4>

  <ol>
    <li>No criteria available.</li>
    <li>Not enough clinical information to meet criteria after 3 requests for necessary information. (Including due diligent effort)</li>
    <li>Does not meet criteria.</li>
    <li>Experimental/Investigational</li>
    <li>Service requested is not a covered benefit.</li>
    <li>Client policy, e.g.: requests with more quantity than normally allowed, requests with a higher dollar limit than allowed.</li>
    <li>MD Consults (example: Clinician unable to make a determination due to case complexity and/or ambiguity of criteria, exceeds approvable inpatient days).</li>
    <li>Clinician judgment.</li>
  </ol>

  <h4>MD Referral Documentation Criteria:</h4>

  <ol>
    <li>Services requested include procedure codes, description of services, dates of service, and the number of inpatient days requested if applicable.</li>
    <li>Summary...</li>
  </ol>

</div>'></ToolTipClinicalAuditReviewForm>  */}
                            <div
                              key={question}
                              className={`item-wrap ${
                                isQuestionActive ? "active" : ""
                              }`}
                              onClick={(event) =>
                                handleQuestionClick(category, question, event)
                              }
                            >
                              <div className="item">
                                {questionData.AutoCalculated === 1 ? (
                                  <PrecisionManufacturingIcon />
                                ) : (
                                  <span className="sub-blank"></span>
                                )}

                                <span className="sub-category">{question}</span>
                              </div>
                              <div className="item">
                                Parameters: {questionData.Parameters}
                              </div>
                              <div className="inline-wrap">
                                <div class="item">
                                  Max Score: {questionData["Max Score"]}{" "}
                                </div>
                                <div class="item">| </div>
                                <div className="item">
                                  <span
                                    className={`inline ${
                                      isQuestionActive ? "visible" : ""
                                    }`}
                                  >
                                    {questionData.NA === "Yes" ? (
                                      <>
                                        <label>
                                          <input
                                            type="radio"
                                            disabled
                                            value="NA"
                                            checked={
                                              selectedAnswers[category]?.[
                                                questionData.Question_ID
                                              ]?.answer === "NA"
                                            }
                                            onChange={(e) =>
                                              handleRadioChange(
                                                e,
                                                category,
                                                questionData.Question_ID,
                                                questionData.Parameters,
                                                questionData
                                              )
                                            }
                                          />
                                          NA
                                        </label>
                                      </>
                                    ) : (
                                      <></>
                                    )}
                                    <label>
                                      <input
                                        type="radio"
                                        value="No"
                                        disabled
                                        checked={
                                          selectedAnswers[category]?.[
                                            questionData.Question_ID
                                          ]?.answer === "No"
                                        }
                                        onChange={(e) =>
                                          handleRadioChange(
                                            e,
                                            category,
                                            questionData.Question_ID,
                                            questionData.Parameters,
                                            questionData
                                          )
                                        }
                                      />
                                      No
                                    </label>
                                    <label>
                                      <input
                                        type="radio"
                                        value="Yes"
                                        disabled
                                        checked={
                                          selectedAnswers[category]?.[
                                            questionData.Question_ID
                                          ]?.answer === "Yes"
                                        }
                                        // checked={selectedAnswers[category]?.[questionData.Question_ID]?.answer === "Yes" || questionData.Decision === "Yes"}
                                        onChange={(e) =>
                                          handleRadioChange(
                                            e,
                                            category,
                                            questionData.Question_ID,
                                            questionData.Parameters,
                                            questionData
                                          )
                                        }
                                      />
                                      Yes
                                    </label>
                                  </span>
                                </div>
                              </div>
                            </div>
                          </>
                        );
                      })}
                    </div>
                  )}
                </div>
              ))}
              {user == "Auditor" && (
                <div class="resetBtn">
                  <button className="smallBtn" onClick={handleReset}>
                    Reset All
                  </button>
                </div>
              )}
            </div>
          </div>

          <div className="body-section">
            <div className="container">
              {activeQuestion && (
                <>
                  <div className="box_wrap">
                    <div className="col-hdr">
                      <h2>CARE MANAGEMENT PLATFORM INFORMATION </h2>
                    </div>

                    <div className="box">
                      <div className="auditBox1-body">
                        <table className="contentTable">
                          {data[activeCategory][activeQuestion]?.[
                            "Information in the system"
                          ]
                            .split("\n")
                            .map((line, index) => (
                              <tr>
                                <td
                                  className={`td-head ${
                                    isMagnifying ? "magnify" : ""
                                  }`}
                                >
                                  {" "}
                                  {line}{" "}
                                </td>
                              </tr>
                            ))}
                        </table>
                      </div>
                    </div>
                  </div>
                  <div className="box_wrap">
                    <div className="col-hdr">
                      <h2>CLINICAL INFORMATION </h2>
                      {/* <a class="btnzoom" href="#open-modal">
                                                <img src="img/expand2.svg" alt="expand button" />
                                            </a> */}
                    </div>

                    <div className="box">
                      <div className="auditBox1-body">
                        <table className="contentTable">
                          {data[activeCategory][activeQuestion]?.[
                            "Clinical Information"
                          ]
                            .split("\n")
                            .map((line, index) => (
                              <tr>
                                <td
                                  className={`td-head ${
                                    isMagnifying ? "magnify" : ""
                                  }`}
                                >
                                  {" "}
                                  {line}{" "}
                                </td>
                              </tr>
                            ))}
                        </table>
                      </div>
                    </div>
                  </div>
                  <div className="box_wrap">
                    <div className="col-hdr">
                      <h2>OTHER SOURCES </h2>
                    </div>

                    <div className="box">
                      <div className="auditBox1-body">
                        <table className="contentTable">
                          {data[activeCategory][activeQuestion]?.[
                            "Other Sources"
                          ]
                            .split("\n")
                            .map((line, index) => (
                              <tr>
                                <td
                                  className={`td-head ${
                                    isMagnifying ? "magnify" : ""
                                  }`}
                                >
                                  {" "}
                                  {line}{" "}
                                </td>
                              </tr>
                            ))}
                        </table>
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
            {showYesNobutton && (
              <div className="footer-wrap">
                <div className="ans-section">
                  <div className="text-section">Is this correct?</div>
                  <div className="form">
                    <label>
                      <input
                        type="radio"
                        value="Yes"
                        // disabled={isSaveDisabled}
                        disabled
                        checked={selectedOption === "Yes"}
                        onChange={handleOptionChange}
                      />
                      Yes
                    </label>
                    <label>
                      <input
                        disabled
                        type="radio"
                        value="No"
                        // disabled={isSaveDisabled}
                        checked={selectedOption === "No"}
                        onChange={handleOptionChange}
                      />
                      No
                    </label>

                    {showNAbutton && (
                      // <div className="btn-section" onClick={handleNAButtonClick}>
                      //      </div>

                      <label>
                        <input
                          type="radio"
                          // disabled={isSaveDisabled}
                          disabled
                          value="NA"
                          checked={selectedOption === "NA"}
                          onChange={handleOptionChange}
                        />
                        NA
                      </label>
                    )}

                    {showAdditionalFields && (
                      <>
                        {console.log(data[activeCategory][activeQuestion])}
                        <select
                          disabled
                          className="selectaudit"
                          value={value}
                          onChange={handleChangeselect}
                        >
                          <option value="">Select Error Type</option>
                          {data[activeCategory][activeQuestion].Error_Type.map(
                            (error) => (
                              <option key={error.ID} value={error.ID}>
                                {error.Error}
                              </option>
                            )
                          )}
                        </select>

                        {user == "Auditor" && (
                          <textarea
                            value={commentValue}
                            className="selectaudittextarea"
                            disabled={isSaveDisabled}
                            onChange={(e) => handlecommentchange(e)}
                            rows="2"
                            cols="50"
                          ></textarea>
                        )}
                        {user != "Auditor" && (
                          <textarea
                            value={commentValue}
                            className="selectaudittextarea"
                            disabled
                            onChange={(e) => handlecommentchange(e)}
                            rows="2"
                            cols="50"
                          ></textarea>
                        )}
                      </>
                    )}
                    {user == "Auditor" && (
                      <button
                        className="btnsave"
                        disabled={isSaveDisabled}
                        onClick={handleSave}
                      >
                        Save
                      </button>
                    )}

                    {/* <button className='btnrebuttal' disabled={isSaveDisabled} onClick={handleRebuttal}><span style={{marginRight:'10px',marginLeft:'-20px'}}>+</span>Rebuttal</button> */}

                    {/* {isRebuattalClicked && <Rebuttal/>} */}
                  </div>
                </div>
                <div className="qs-section">
                  <div className="form">
                    {user == "Auditor" && (
                      <button
                        className="btnsub"
                        disabled={isSubmitDisabled}
                        onClick={handleSubmit}
                      >
                        Submit
                      </button>
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      {isPdfVisible && (
        <CustomModal
          isOpen={isModalOpen}
          onClose={closeModal}
          urlpdF={FaxurlpdF}
        />
      )}

      <ConfirmationModal
        isOpen={modalIsOpen}
        onClose={closeCModal}
        onConfirm={handleConfirm}
        message="Are you sure you don't want to save this question?"
      />
      <ModalPopUp
        isOpen={modalIsOpenMessage}
        onClose={closeModal}
        autoHideTimeout="10000"
        message={qualityScore}
      ></ModalPopUp>

      {isRebuattalClicked && (
        <Rebuttal
          isOpen={isRebuattalClicked}
          onClose={() => setIsRebuttalClicked(false)}
          questionsFromAuditData={questionsFromAuditData}
          dataToPass={data}
          onSubmitHandler={handlesetIsSubmitInRebuttalPressed}
          modalClose={handleIsModalClosed}
          buttonAreYouSure={buttonAreYouSure}
          setIsViewRebuttalactive={setIsViewRebuttalactive}
          isViewRebuttalactive={isViewRebuttalactive}
          showViewRebuttal={showViewRebuttal}
          setButtonAreYouSureToFalse={() => {
            setButtonAreYouSure(false);
          }}
          statusOfRebuttalPopup={statusOfRebuttalPopup}
          isYesButtonClicked={isYesButtonClicked}
        />
      )}

      {isModalClosed &&
        !isSubmitInRebuttalPressed &&
        !showViewRebuttal &&
        statusOfRebuttalPopup != "View" && (
          <PopOutModal
            isOpen={isModalClosed}
            onClose={() => {
              setIsModalClosed(false);
              setButtonAreYouSure(true);
              // setIsSubmitInRebuttalPressed(false)
            }}
            isSmall="true"
            content={
              <>
                <div
                  style={{
                    height: "20vh",
                    width: "20vw",
                    fontSize: "24px",
                    padding: "20px",
                    transform: "translateY(25%)",
                    textAlign: "center",
                  }}
                >
                  Are you sure to proceed without submitting rebuttal?
                </div>
                <div style={{ textAlign: "right", padding: "20px" }}>
                  <button
                    style={{
                      padding: "10px 16px",
                      borderRadius: "5px",
                      color: "red",
                      background: "white",
                      border: "1px solid red",
                      cursor: "pointer",
                      margin: "0 10px",
                    }}
                    onClick={() => {
                      setIsModalClosed(false);
                      setIsYesButtonClicked(true);
                    }}
                  >
                    Yes
                  </button>
                  <button
                    style={{
                      padding: "10px 16px",
                      borderRadius: "5px",
                      color: "red",
                      background: "white",
                      border: "1px solid red",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      setIsRebuttalClicked(true);
                      setIsYesButtonClicked(false);
                    }}
                  >
                    No
                  </button>
                </div>
              </>
            }
          ></PopOutModal>
        )}

      {/* {isSubmitInRebuttalPressed && 
            
            <PopOutModal isSmall='true' isOpen={isSubmitInRebuttalPressed} onClose={()=>setIsSubmitInRebuttalPressed(false)} content={
                <>
                 <div style={{height:'20vh', width:'20vw',fontSize:'24px',padding:'20px',transform: 'translateY(25%)',textAlign:'center'}}>
                Rebuttal Sumitted successfully
                </div>
                <div style={{textAlign:'right',padding:'20px'}} >
                <button style={{padding:'10px 16px',borderRadius:'5px',color:'red', background:'white',border:'1px solid red',cursor:'pointer'}} onClick={()=>setIsSubmitInRebuttalPressed(false)} >Cancel</button>
                </div>
                
                </>
               

            }></PopOutModal>
            } */}
    </>
  );
}

export default ClinicalReviewAuditForRebuttal;
